var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassenger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20.864,
    viewBox: "0 0 17 20.864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M57.447,78.682h2.007a.386.386,0,0,0,.386-.386V76.75a1.159,1.159,0,0,0-1.159-1.159H50.75l-.6-2.7h6.214a.386.386,0,0,0,.386-.386V70.954a.386.386,0,0,0-.386-.386h-6.73l-1.259-5.661A1.153,1.153,0,0,0,47.245,64H45.159a.386.386,0,0,0-.377.47l3.057,13.754-3.78,6.048a.386.386,0,0,0,.328.591H60.613a.386.386,0,0,0,.328-.591Zm-1.47-7.341v.773H48.25v-.773ZM45.641,64.773h1.6a.389.389,0,0,1,.377.3l1.22,5.493h-.979a.386.386,0,0,0-.386.386V72.5a.386.386,0,0,0,.386.386h1.494l.705,3.175a.386.386,0,0,0,.377.3h8.241a.386.386,0,0,1,.386.386v1.159H48.559Zm-.559,19.318,3.381-5.409h8.073l3.382,5.409Z",
    transform: "translate(-44 -64)",
    fill: "#666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassenger);
export default __webpack_public_path__ + "static/media/passenger.ab988ab99a474195e5f23171411a2dbd.svg";
export { ForwardRef as ReactComponent };